import { render, staticRenderFns } from "./swiper.vue?vue&type=template&id=7e61fd62"
import script from "./swiper.vue?vue&type=script&lang=js"
export * from "./swiper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/www-root/data/www/view.sessiondesign.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e61fd62')) {
      api.createRecord('7e61fd62', component.options)
    } else {
      api.reload('7e61fd62', component.options)
    }
    module.hot.accept("./swiper.vue?vue&type=template&id=7e61fd62", function () {
      api.rerender('7e61fd62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/common/components/awesome-swiper/swiper.vue"
export default component.exports